export default __webpack_public_path__ + "static/media/ico-postgress-score-low.a3686d5b.svg";